export const getMoveDirection = (
    prevIndex: number,
    nextIndex: number,
    length: number
): 'next' | 'previous' | undefined => {
    const prev = prevIndex % length;
    const next = nextIndex % length;

    if (next === (prev + 1) % length) return 'next';
    if (next === (prev - 1 + length) % length) return 'previous';
    return undefined;
};
